export default __webpack_public_path__ + "static/13_18-600dbbf00720f017f9c7076183abe868.png";